import React from "react";
import { useAuth } from "../auth/AuthContext";
import { canAccessDeals } from "../utils/permissions";
import { useT } from "../i18n";

interface ProtectedDealsRouteProps {
  children: React.ReactNode;
}

const ProtectedDealsRoute: React.FC<ProtectedDealsRouteProps> = ({
  children,
}) => {
  const { user } = useAuth();
  const t = useT();

  if (!canAccessDeals(user)) {
    return (
      <div className="flex flex-col items-center justify-center min-h-screen bg-gray-50">
        <div className="text-center">
          <div className="mb-8">
            <i className="fa-solid fa-ban text-6xl text-gray-400"></i>
          </div>
          <h1 className="text-4xl font-bold text-gray-900 mb-4">{t("accessDenied.code")}</h1>
          <h2 className="text-2xl font-semibold text-gray-700 mb-4">
            {t("accessDenied.title")}
          </h2>
          <p className="text-gray-600 mb-8 max-w-md">
            {t("accessDenied.body")}
          </p>
          <button
            onClick={() => window.history.back()}
            className="px-6 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors"
          >
            <i className="fa-solid fa-arrow-left mr-2"></i>
            {t("accessDenied.goBack")}
          </button>
        </div>
      </div>
    );
  }

  return <>{children}</>;
};

export default ProtectedDealsRoute;
